import type { ReactNode } from 'react';

import { CallMergeOutlined } from '@mui/icons-material';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import ForkRightOutlined from '@mui/icons-material/ForkRightOutlined';

import type { ProposalStatus } from 'api/projectVersioning/types';

const proposalStatusIcons: Record<ProposalStatus, ReactNode> = {
  Draft: <ForkRightOutlined />,
  // TODO: Add the correct icon for the published status
  Published: <ForkRightOutlined />,
  Discarded: <DoNotDisturbIcon />,
  Merged: <CallMergeOutlined />
};

const StatusIcon = ({ status }: { status: ProposalStatus }) => {
  return proposalStatusIcons[status] ?? <ForkRightOutlined />;
};

export default StatusIcon;
